import { patch } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const useDepositStartMoneyMutation = () => {
  const branchId = useBranchId();

  const { t } = useTranslation("");
  const mutation = useMutation({
    onSuccess: () => {
      toast.success(t("success.update"));
    },
    mutationFn: ({
      account_id,
      money_at_start_of_day,
    }: {
      account_id: string;
      money_at_start_of_day: string;
    }) =>
      patch(
        `/internal/secure/pos/v1/personnel/add/new/record/start/deposit/${branchId}/${account_id}`,
        { money_at_start_of_day }
      ),
  });
  return mutation;
};

export default useDepositStartMoneyMutation;
